import React, { Component } from "react";
import Select from "react-select";
import "../../styles/select.css";
import { UncontrolledTooltip, Badge } from "reactstrap";

class AutocompleteCustom extends Component {
  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleOnInputChange = this.handleOnInputChange.bind(this);
    this.triggerChange = this.triggerChange.bind(this);
    this.state = {
      optionsValues: [],
      value: [],
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }

  handleSelectChange(value) {
    this.props.liftState(this.props.component, value);
  }
  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid2;
  }

  triggerChange() {
    let { currentVal } = this.state;
    let { options, ajaxLoad, ajaxOptions } = this.props.component;
    let lgs = this.props.liftGlobalState;
    !options && (options = []);
    if (ajaxLoad) {
      let opt = [];
      const elem = this;
      let allV = { "$x$": currentVal }; // add 
      // await fetch()
      // Meteor.call("directQuery", ajaxOptions, allV, function(
      //   error,
      //   result
      // ) {
      //   result.map(res => {
      //     opt.push({
      //       label: res[ajaxOptions.label],
      //       value: res[ajaxOptions.value]
      //     });
      //   });
      //   elem.setState({ optionsValues: opt });
      // });
    }
  }



  handleOnInputChange(currentVal) {
    const WAIT_INTERVAL = 1;
    clearTimeout(this.timer);
    this.setState({ currentVal });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  componentWillMount() {
    this.timer = null;
  }

  componentDidMount() {
    // Fill in default value
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    // console.log({defaultValue})
    if (
      pageData &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, this.props.component.default);
    }
    let { options } = this.props.component;
    !options && (options = []);
    this.setState({ optionsValues: options });
  }

  render() {
    const {
      elementProps,
      prepend,
      name,
      label,
      description, isReadOnly
    } = this.props.component;


    let { conditionalRender } = this.props;

    let { currentPage, fileFolder, formState, openmodals, pageData } = this.props.parentState;
    let isReadOnly1 = false;
    if ((formState != 'edit' && fileFolder.isOpen) || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit' && fileFolder.isOpen) || conditionalRender == 'readonly') {
      isReadOnly1 = true;
    }

    let boxvalue;
    let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : "";
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    // console.log({conditionalRender})

    return (
      <div className={`form-group ${this.props.component.widths.parent}`}>
        {label &&
          label != "" && (
            <span>
              <label
                id={tooltipID}
                className="col-form-label col-form-label-sm nopadding"
              >
                {label}
              </label>
              {
                description ? (<UncontrolledTooltip placement="right" target={tooltipID}>
                  {description}
                </UncontrolledTooltip>) : ""
              }
              {" " + this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name] ? (
                <span>
                  <UncontrolledTooltip placement="right" target={tooltipID2}>
                    can not empty{" "}
                  </UncontrolledTooltip>
                </span>
              ) : (
                ""
              )}
            </span>
          )}
        {conditionalRender && conditionalRender != 'blank' &&
          <div className="input-group input-group-sm">
            {this.props.component.prepend &&
              this.props.component.prepend != "" && (
                <div className="input-group-prepend">
                  <div className="input-group-text">{prepend}</div>
                </div>
              )}
            <div
              className="col-12 form-control form-control-sm"
              style={{ border: 0, padding: 0 }}
            >
              <Select
                id={tooltipID2}
                className={
                  this.props.parentState.errorMessages != undefined &&
                    this.props.parentState.errorMessages[name]
                    ? "validationErrorBox"
                    : ""
                }
                closeOnSelect={!elementProps.stayOpen}
                disabled={elementProps.disabled}
                multi
                onChange={this.handleSelectChange}
                onInputChange={this.handleOnInputChange}
                options={this.state.optionsValues}
                placeholder="Select your favourite(s)"
                removeSelected={elementProps.removeSelected}
                rtl={elementProps.rtl}
                value={boxvalue}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default AutocompleteCustom;
